module.exports = __webpack_public_path__ + "static/media/walmart.b6bb032b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/walmart.jpg
// module id = 1329
// module chunks = 0